export default "__VITE_ASSET__Cm9wX8QC__"